module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-form/promotiondetails-form.component.css
// module id = ./src/app/hrms/serviceregister/promotiondetails/promotiondetails-form/promotiondetails-form.component.css
// module chunks = main